import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

import chatModelIcon from '../assets/Edit/chat-model.png';
import realModelIcon from '../assets/Edit/real-model.png';
import utilModelIcon from '../assets/Edit/util-model.png';
import { useAppSelector } from '../state/hooks';
import { ChatModelType } from '../types';

export interface ILLModel {
  id: ChatModelType;
  name: string;
  icon: string;
  desc: string;
}

const getLLMModelIcon = (id: ChatModelType) => {
  if (id === ChatModelType.Chat) {
    return chatModelIcon.src;
  }
  if (id === ChatModelType.Util) {
    return utilModelIcon.src;
  }
  return realModelIcon.src;
};

export function useLLModels() {
  const { t } = useTranslation();
  const chatModels = useAppSelector((state) => state.edit.chatModels);
  const defaultModels = useMemo(() => {
    return [
      {
        id: ChatModelType.Chat,
        name: t('chatModelName'),
        desc: t('chatModelDescription'),
      },
      {
        id: ChatModelType.Util,
        name: t('utilModelName'),
        desc: t('utilModelDescription'),
      },
    ];
  }, [t]);

  const models = useMemo(() => {
    const validModels = chatModels.length > 0 ? chatModels : defaultModels;
    return validModels.map((model) => ({
      ...model,
      icon: getLLMModelIcon(model.id),
    }));
  }, [chatModels, defaultModels]);

  return { models };
}
